import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { filmTrailerDisplayTextValidatorSchema } from '../../trailer/types/display-text';
export const defaultFilmTrailerButtonDisplayText = {
    playTrailerButtonLabel: 'Play trailer',
    failedToLoadTrailerTitle: 'Sorry, something went wrong.',
    failedToLoadTrailerRetryButtonLabel: 'Retry'
};
export const filmTrailerButtonDisplayTextValidatorSchema = Object.assign(Object.assign({}, filmTrailerDisplayTextValidatorSchema), { playTrailerButtonLabel: Validator.optional(nonEmptyStringValidator) });
export const filmTrailerButtonDisplayTextValidator = Validator.object(filmTrailerButtonDisplayTextValidatorSchema);
